export const CalculationEngineConstants = { 
    SupportedStates: [
        {fullName: 'CA: California', abbv: 'CA'}, 
        {fullName: 'CT: Connecticut', abbv: "CT"}, 
        {fullName: 'DC: District of Columbia', abbv: 'DC'},
        {fullName: 'FL: Florida', abbv: 'FL'},
        {fullName: 'GA: Georgia', abbv: 'GA'},
        {fullName: 'IL: Illinois', abbv: 'IL'},
        {fullName: 'MA: Massachusetts', abbv: 'MA'},
        {fullName: 'MD: Maryland', abbv: 'MD'},
        {fullName: 'NC: North Carolina', abbv: 'NC'},
        {fullName: 'NJ: New Jersey', abbv: 'NJ'},
        {fullName: 'NY: New York', abbv: 'NY'},
        {fullName: 'PA: Pennsylvania', abbv: 'PA'},
        {fullName: 'TX: Texas', abbv: 'TX'},
        {fullName: 'UT: Utah', abbv: 'UT'},
        {fullName: 'VA: Virginia', abbv: 'VA'}],
    FederalFilingStatuses: [
        {name: 'Single', code: 'SINGLE'},
        {name: 'Married', code: 'MARRIED'},
        {name: 'Married Use Single Rate', code: 'MARRIED_USE_SINGLE_RATE'},
        {name: "Nonresident Alien", code: 'NONRESIDENT_ALIEN'}
    ],
    StateFilingStatuses: [
        {name: 'Single', code: 'S'},
        {name: 'Married', code: 'M'},
        {name: 'Head of Household', code: 'H'},
    ],
    NYFilingStatuses: [
        {name: 'Single', code: 'S'},
        {name: 'Married', code: 'M'},
        {name: 'Head of Household', code: 'H'},
        {name: 'Married but use single rate', code:'MH'}
    ],
    GAFilingStatuses: [
        {name:'Single', code: 'A'},
        {name: 'Married Filing Joint both spouses working', code: 'B'},
        {name: 'Married Filing Joint one spouse working', code: 'C'},
        {name: 'Married Filing Seperate', code:'D'},
        {name: 'Head of Household', code: 'E'}
    ],
    NJFilingStatuses: [
        {name:'Single', code: 'S'},
        {name: 'Married Filing Jointly', code: 'MJ'},
        {name: 'Married Filing Seperately', code: 'MS'},
        {name: 'Head of Household', code:'H'},
        {name: 'Qualified Widower', code: 'QW'}
    ],
    DCFilingStatuses: [
        {name:'Single', code: 'S'},
        {name: 'Married Or Domestic Partners Filing Jointly', code: 'MJ'},
        {name: 'Married Or Domestic Partners Filing Seperately on same return', code: 'MDS'},
        {name: 'Married Filing Seperately', code:'MS'},
        {name: 'Head of Household', code:'H'},
        {name: 'Surviving Spouse', code: 'SS'}
    ],
    UTMDFilingStatuses: [
        {name: 'Single', code: 'S'},
        {name: 'Married', code: 'M'},
        {name: 'Married but use single rate', code:'MH'}
    ],
    GrossPayTypes: [
        {name: 'Annually', code: 'ANNUALLY'},
        {name: 'Per Pay Period', code: 'PAY_PER_PERIOD'}
    ],
    PayFrequencyTypes: [
        {name: 'Daily', code: 'DAILY'},
        {name: 'Weekly', code: 'WEEKLY'},
        {name: 'Bi-Weekly', code: 'BI_WEEKLY'},
        {name: 'Semi-Monthly', code: 'SEMI_MONTHLY'},
        {name: 'Monthly', code: 'MONTHLY'},
        {name: 'Quarterly', code: 'QUARTERLY'},
        {name: 'Semi-Annually', code: 'SEMI_ANNUAL'},
        {name: 'Annually', code: 'ANNUAL'}
    ],
    WithholdingCodes: ['A', 'B', 'C', 'D', 'E', 'F'],
    totalAllowanceStates : ['NY', 'DC', 'GA', 'MA', 'NJ', 'MD', 'NC'],
    basicAllowanceStates : ['IL'],
    regularAllowanceStates : ['CA'],
    totalAllowanceNYCStates : ['NY'],
    filingStatusStates : ['NC', 'DC', 'GA', 'UT', 'NJ', 'NY', 'CA', 'MD'],
    sdiStates : ['NJ', 'NY'],
    suiStates : ['NJ'],
    withholdingCodeStates : ['CT'],
    familyLeaveStates : ['NJ', 'NY'],
    personalExemptionStates : ['VA'],
    addressStates : ['NY', 'PA', 'MD'],
    residentStates : ['NY', 'PA', 'MD'],
    stateCodes : [
        {abbv: 'NJ', code: "34" }, 
        {abbv: 'NY', code: "36" }] //used for SUI, SDI, and FLI
};



// WEBPACK FOOTER //
// ./src/app/calculation-engine/calculation-engine-constants.ts